import { useQuery } from '@tanstack/react-query';
import { getPaymentOptions } from '@/lib/api/donations';
import { useRegionDetection } from './useRegionDetection';

/**
 * Hook to fetch available payment options
 * Detects region from timezone (more reliable than browser locale)
 * Backend can also use IP detection as fallback/override
 */
export function usePaymentOptions() {
  const { detectedRegion, locale, timezone } = useRegionDetection();

  return useQuery({
    queryKey: ['payment-options', detectedRegion, locale, timezone],
    queryFn: () =>
      getPaymentOptions({
        region: detectedRegion,
        locale,
        timezone,
      }),
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
}
